import { AfterViewInit, Component, Input } from '@angular/core';
@Component({
	selector: 'header-mobile-component',
	templateUrl: 'header.mobile.component.html',
	styleUrls: ['./header.mobile.component.scss'],
})
export class HeaderMobileComponent implements AfterViewInit {
	@Input() public color: string;
	@Input() public title: string;

	constructor() {}

	ngAfterViewInit(): void {
		document.getElementById(`header-mobile-component-${this.color}`).style.backgroundColor = this.color;
	}
}
